module.exports = __webpack_public_path__ + "assets/img/browse.90acdf52.png";